import React, { useState } from "react";
import "./GoldenButton.css";

const GoldenButton = ({
  children,
  onClick,
  variant = "primary",
  className = "",
  ...props
}) => {
  const [rippleStyle, setRippleStyle] = useState(null);

  const handleClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();

    const size = Math.max(rect.width, rect.height);
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top - size / 2;

    setRippleStyle({
      width: size,
      height: size,
      left: x,
      top: y,
    });

    setTimeout(() => setRippleStyle(null), 600);

    if (onClick) onClick(e);
  };

  return (
    <button
      className={`golden-btn ${variant} ${className}`}
      onClick={handleClick}
      {...props}
    >
      {/* Shine Layer */}
      <span className="shine-layer"></span>

      {/* Ripple */}
      {rippleStyle && (
        <span
          className="ripple"
          style={rippleStyle}
        ></span>
      )}

      <span className="btn-text">{children}</span>
    </button>
  );
};

export default GoldenButton;
